const config = {
  sessionInformation: {
    year: 2026,
    dates: "14-19",
    theme: "Grace",
    scripture: "Titus 2:11-14",
    hymnNumber: 266,
    hymnName: "Grace 'Tis a Charming Sound",
  },
  features: {
    news: false,
    pbhSearch: false,
    moreMusic: false,
  },
  calendarDetails: [
    {
      date: "April 25",
      details: "Spring Work Day",
    },
    {
      date: "May 16",
      details: "Spring Work Day",
    },
    {
      date: "June 13",
      details: "Spring Work Day",
    },
  ],
  trustees: [
    { name: "Larry Dalton", title: "President" },
    { name: "Joey Lowrance", title: "Vice President" },
    { name: "Jeff Coker", title: "Secretary/Treasurer" },
    { name: "Russell Elsenbrock" },
    { name: "Gerald Hendrix" },
    { name: "David Moore" },
    { name: "Susan Schneider" },
    { name: "Kathy Taylor" },
    { name: "John Watson" },
  ],
};

export default config;
